import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggingService } from '../../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-other-kp-modal-mail-sender',
  templateUrl: './modal-mail-sender.component.html',
  styleUrls: ['./modal-mail-sender.component.sass']
})
export class ModalOtherKpMailSenderComponent implements OnInit {
  http: HttpClient;
  spinner: NgxSpinnerService;
  sanitizer: DomSanitizer;
  private isVisible: boolean = false;
  mail = {participant:undefined, idAuction:undefined, mailTo:undefined, mailCopy:undefined, mailTopic:undefined,  mailBody:undefined};

  returnValue: any

  constructor(private _http: HttpClient, private _spinner: NgxSpinnerService, private _sanitizer: DomSanitizer, private loggingService: LoggingService) {
    this.http = _http;
    this.spinner = _spinner;
    this.sanitizer = _sanitizer
   }

  ngOnInit() {
    $('#modalOtherKpMailSender').on('show.bs.modal', function () {
      $('#modalAuctionDetail').css('z-index', 1030);
      $('#modalOtherKpDetail').css('z-index', 1040);
    });

    $('#modalOtherKpMailSender').on('shown.bs.modal', function () {
      $('#modalOtherKpMailSender').css('z-index', 1070);
      $('.modal-backdrop:last').css('z-index', 1065);
    });

    $('#modalOtherKpMailSender').on('hidden.bs.modal', function () {
      $('#modalAuctionDetail').css('z-index', 1041);
      $('#modalOtherKpDetail').css('z-index', 1060);
    });
  }

  onSave(){
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.ModalOtherKpMailSenderComponent.onSave', null, 'Save started');
      
      if($("#myform").find('.form-control:invalid').length !== 0){
        console.log("invalid!");
        this.loggingService.logFinish(_xid, 'App.Components.ModalOtherKpMailSenderComponent.onSave', null, 'Save cancelled - invalid form');
      }
      else{
        this.sendEmail();
        this.loggingService.logFinish(_xid, 'App.Components.ModalOtherKpMailSenderComponent.onSave', null, 'Save completed');
      }
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.ModalOtherKpMailSenderComponent.onSave', _error, null, 'Save failed');
      throw _error;
    }
  }

  public sendEmail() {
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.ModalOtherKpMailSenderComponent.sendEmail', null, 'Send email started');
    
    this.http.post<string>(apiServer + "/otherKp/SendEmail", this.mail).subscribe(resp => {
      this.returnValue.value = this.sanitizer.bypassSecurityTrustHtml(resp)
      setTimeout(() => {
        this.returnValue.value = ""
      }, 5000)
      this.loggingService.logFinish(_xid, 'App.Components.ModalOtherKpMailSenderComponent.sendEmail', null, 'Send email completed');
    }, error => {
      this.loggingService.logError(_xid, 'App.Components.ModalOtherKpMailSenderComponent.sendEmail', error, null, 'Send email failed');
    });
  }
  
  public mailToCommercialOffer(code, distributerParticipant, returnedValue){
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.ModalOtherKpMailSenderComponent.mailToCommercialOffer', null, 'Mail to commercial offer started');
    
    this.spinner.show();

    this.http.get<Array<string>>(apiServer + "/otherKp/"+ code + "/" + distributerParticipant + "/" + 0)
      .subscribe(resp => {
      this.spinner.hide();
      this.mail.participant = distributerParticipant;
      this.mail.idAuction = code;
      this.mail.mailTo = resp["mailTo"];
      if(resp["mailFrom"] != null){
        this.mail.mailCopy = resp["mailFrom"];
      }else{
        this.mail.mailCopy = " ";
      }
      this.mail.mailTopic = resp["mailTopic"];
      this.mail.mailBody = resp["mailBody"];
      this.loggingService.logFinish(_xid, 'App.Components.ModalOtherKpMailSenderComponent.mailToCommercialOffer', null, 'Mail to commercial offer completed');
    }, error => {
      this.spinner.hide();
      this.loggingService.logError(_xid, 'App.Components.ModalOtherKpMailSenderComponent.mailToCommercialOffer', error, null, 'Mail to commercial offer failed');
    });

    this.returnValue = returnedValue
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-detail/modal-mail-sender/modal-mail-sender.component.ts